import { createPortal } from 'react-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from '@scholastic/mockingjay';
import { routes } from '@/routes';

// Not at import: main.tsx renders App only after LaunchDarkly is ready, so
// loaders read real flags.
let router: ReturnType<typeof createBrowserRouter> | undefined;

export default function App() {
  router ??= createBrowserRouter(routes);

  return (
    <>
      <RouterProvider router={router} />
      {/* Portal to body so the toaster escapes the `#root { isolation: isolate }`
          stacking context and renders above modal dialogs, whose overlays Radix
          also portals to body. */}
      {createPortal(<Toaster />, document.body)}
    </>
  );
}
